<nav class="bottom-bar is-mobile">
  <ul>
    @if (bottomBarButtons$ | async; as bottomBarButtons) {
      @for (button of bottomBarButtons.list; track button.text; let index = $index; let count = $count) {
        <li
          class="semibold"
          [class.active]="activeList[index]">
          <a
            mat-icon-button
            [searchTriggerFor]="index === 1 && headerSearch"
            [color]="button.color"
            [class]="button.class"
            [routerLinkActive]="'active'"
            [routerLink]="button.link?.length ? (button.link | routeTranslate) : button.link"
            [queryParams]="button.queryParams"
            (click)="onActiveChange(index); button.onClick ? button.onClick() : null">
            @if (button.icon) {
              <sharry-icon [registryName]="button.icon"></sharry-icon>
            }
            @if (button.avatar) {
              <span
                [avatar]="{
                  size: 'small',
                  imgSize: '38px',
                  user: bottomBarButtons.user,
                }"></span>
            }
          </a>
          @if (button.text) {
            {{ button.text | i18next }}
          }
        </li>
      }
    }
  </ul>
</nav>
<sharry-header-search
  #headerSearch
  [resetFilter]="canClearFilter()"></sharry-header-search>
